import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-navy-900 border-t border-navy-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <img src="/images/logo.png" alt="Tritech Data" className="h-8" />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-md">
              Secure, AI-powered solutions for government and enterprise clients.
              On-premise AI appliances with real-time analytics and operational security.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-slate-200 uppercase tracking-wider mb-4">Solutions</h4>
            <ul className="space-y-2">
              <li><Link to="/aibox" className="text-sm text-slate-400 hover:text-cyan-400 transition-colors">AI-Box</Link></li>
              <li><Link to="/products" className="text-sm text-slate-400 hover:text-cyan-400 transition-colors">Products</Link></li>
              <li><Link to="/central" className="text-sm text-slate-400 hover:text-cyan-400 transition-colors">Tritech Central</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-slate-200 uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>61 Kaki Bukit Avenue 1</li>
              <li>#04-44, Shun Li Industrial Park</li>
              <li>Singapore 417943</li>
              <li className="pt-2">
                <a href="mailto:info@tritechdatasg.com" className="hover:text-cyan-400 transition-colors">
                  info@tritechdatasg.com
                </a>
              </li>
              <li>
                <a href="mailto:support@tritechdatasg.com" className="hover:text-cyan-400 transition-colors">
                  support@tritechdatasg.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-navy-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between">
          <p className="text-sm text-slate-500">&copy; {new Date().getFullYear()} Tritech Data Pte Ltd. All rights reserved.</p>
          <p className="text-sm text-slate-500 mt-2 sm:mt-0">www.tritechdatasg.com</p>
        </div>
      </div>
    </footer>
  );
}
